export default __webpack_public_path__ + "static/media/2011.e47b0c5d.png";